import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { INSTRUCTOR_FEATURE_KEY } from './keys';
import { instructorReducer } from './reducers/instructor.reducer';
import { InstructorEffects } from './effects/instructor.effects';

export function provideInstructorStore(): EnvironmentProviders[] {
    return [provideState(INSTRUCTOR_FEATURE_KEY, instructorReducer), provideEffects(InstructorEffects)];
}
